import React from 'react';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLitePublicRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { Link } from 'ui-components/common/Link';
import { SectionContentTitleText } from 'app-components/home/sections/components/SectionContentTitleText';
import { SectionTextContentMetaInfo } from 'app-components/home/sections/components/SectionTextContentMetaInfo';

interface SectionContentTextItemProps {
  content: ContentPublicRelayDto;
  profile: ProfileLitePublicRelayDto;
  onClick?: () => void;
}

export const SectionContentTextItem = ({ content, profile, onClick }: SectionContentTextItemProps) => (
  <div onClick={onClick} className={`flex flex-col gap-1 w-full min-w-0 mb-[10px] h-[115px]`}>
    <div className="flex flex-col gap-1">
      <SectionContentTitleText content={content} />
      <SectionTextContentMetaInfo content={content} profile={profile} />
      {content.keywords.length > 0 && (
        <div className="flex flex-row flex-wrap gap-1">
          {content.keywords.slice(0, 3).map((keyword, idx) => (
            <Link key={`keyword-${idx}`} href={`/search?q=${encodeURIComponent(`#${keyword}`)}`}>
              <span className="text-xxxs font-medium text-primary-600 cursor-pointer ">#{keyword}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
    {content.description && (
      <div className="h-9 min-w-0">
        <Link href={`/contents/${content.id}`}>
          <div className="line-clamp-2 text-xxxs font-regular text-gray-700 cursor-pointer break-words overflow-hidden">
            {content.description}
          </div>
        </Link>
      </div>
    )}
  </div>
);
